import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Box, Button, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UniqLinkDataGrid from './components/uniq-link-data-grid';
import UniqLinkForm from './components/uniq-link-form';
import { IUniqLink } from 'types/uniq-link';

const UniqLink: React.FC = () => {
    const theme = useTheme();
    const [openModalUniqLink, setOpenModalUniqLink] =
        React.useState<boolean>(false);
    const [editingUniqLink, setEditingUniqLink] =
        React.useState<IUniqLink | null>(null);

    const handleOpenForm = (link: IUniqLink | null = null) => {
        setEditingUniqLink(link);
        setOpenModalUniqLink(true);
    };

    const handleCloseForm = () => {
        setEditingUniqLink(null);
        setOpenModalUniqLink(false);
    };

    return (
        <Box mt={5}>
            <Box mb={'40px'}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="end"
                >
                    <Typography
                        variant="h3"
                        component="h3"
                        fontSize={28}
                        fontWeight={'bold'}
                        lineHeight={'34px'}
                        color={theme.palette.primary.main}
                    >
                        Quản lý Unique Link
                    </Typography>
                    <Button
                        onClick={() => handleOpenForm()}
                        sx={{
                            minWidth: '230px',
                            fontSize: '20px',
                            textTransform: 'none',
                            fontWeight: '700',
                            lineHeight: '24.2px',
                            borderRadius: '39.06px',
                        }}
                        variant="contained"
                        startIcon={
                            <AddIcon sx={{ fontSize: '40px !important' }} />
                        }
                    >
                        Thêm mới
                    </Button>
                </Box>
            </Box>
            <Card
                elevation={0}
                sx={{
                    borderRadius: '26px',
                }}
            >
                <CardContent
                    sx={{
                        padding: 0,
                        paddingBottom: '0 !important',
                    }}
                >
                    <UniqLinkDataGrid onOpenForm={handleOpenForm} />
                </CardContent>
            </Card>
            {openModalUniqLink && (
                <UniqLinkForm
                    actionType={editingUniqLink ? 'edit' : 'add'}
                    open={openModalUniqLink}
                    onClose={handleCloseForm}
                    uniqLink={editingUniqLink}
                />
            )}
        </Box>
    );
};

export default UniqLink;
